/*
 * bm-dynamatic-shoplift-bridge.js
 *
 * Local-only bridge that carries the active Shoplift price-test marker
 * (`window.__shopliftPriceTestValue`) onto Dynamatic's second-Capo line item.
 *
 * It must be loaded synchronously BEFORE Dynamatic starts so the wrappers are
 * already installed when Dynamatic posts to /cart/add(.js). A fetch Request
 * owns its body as a stream, so only a string body supplied explicitly in the
 * init argument can be inspected or replaced; Request-owned bodies are
 * forwarded untouched. The Dynamatic bundle actually posts with
 * XMLHttpRequest, so XHR open/send are wrapped too and share the same payload
 * and scope validation. An aborted XHR resets readyState to 0, so send bypasses
 * inspection in that case.
 */
(function () {
  "use strict";

  if (window.__bmDynamaticShopliftBridge) return;

  var TARGET_VARIANT_ID = "52091335082257";
  var TARGET_PRODUCT_ID = "10548537655569";
  var WIDGET_ID = "7728";
  // Cart "Best Sellers List" (template 61): adds the Capo at full price with
  // no discount properties.
  var LIST_WIDGET_ID = "2418";
  var LIST_TEMPLATE_ID = "61";
  var DISCOUNT_KEYS = ["__dyn_discount", "__dyn_discount_custom", "__dyn_ct_discount", "_dyn_is_DiscountNode"];
  var MARKER_RE = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(control|variant):([ft])$/i;
  var CART_ADD_RE = /^(?:\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?)?\/cart\/add(?:\.js)?$/;

  var originalFetch = typeof window.fetch === "function" ? window.fetch : null;

  var XHR = null;
  if (typeof XMLHttpRequest === "function") {
    XHR = XMLHttpRequest;
  } else if (window && typeof window.XMLHttpRequest === "function") {
    XHR = window.XMLHttpRequest;
  }
  var xhrPrototype = XHR && XHR.prototype ? XHR.prototype : null;
  var canWrapXhr = !!xhrPrototype &&
    typeof xhrPrototype.open === "function" &&
    typeof xhrPrototype.send === "function" &&
    typeof WeakMap === "function";

  if (!originalFetch && !canWrapXhr) return;

  function isRequestLike(value) {
    return !!value && typeof value === "object" && typeof value.url === "string" && typeof value.method === "string";
  }

  function shallowClone(object) {
    // Null-prototype target plus own data properties so a JSON "__proto__"
    // key is preserved as an own key instead of re-pointing the clone's
    // prototype.
    var clone = Object.create(null);
    var keys = Object.keys(object);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      Object.defineProperty(clone, key, {
        value: object[key],
        writable: true,
        enumerable: true,
        configurable: true,
      });
    }
    return clone;
  }

  function markerRow(row) {
    return Array.isArray(row) && String(row[0]) === TARGET_VARIANT_ID && String(row[3]) === TARGET_PRODUCT_ID;
  }

  function pickHypothesis(test, side) {
    if (!test || !Array.isArray(test.hypotheses)) return null;
    var wantControl = side === "control";
    var found = null;
    for (var i = 0; i < test.hypotheses.length; i++) {
      var hypothesis = test.hypotheses[i];
      if (!hypothesis || hypothesis.isControl !== wantControl) continue;
      if (found) return null;
      found = hypothesis;
    }
    return found;
  }

  // Mirrors Shoplift's own native form: whatever marker Shoplift set on the
  // page is the marker the second Capo gets. Shoplift also sets "control:f"
  // for visitors it blocks or treats as non-test (their visitorTests entry has
  // hypothesisId null / isInvalid true, or there is none), so visitorTests is
  // deliberately not consulted here.
  function scopeIsLive(inst, testId, side) {
    var state = inst.state;
    if (!state || !state.temporary || state.temporary.isMerchant === true) return false;
    var configs = inst.testConfigs;
    if (!Array.isArray(configs)) return false;
    var test = null;
    for (var i = 0; i < configs.length; i++) {
      if (configs[i] && configs[i].id === testId) { test = configs[i]; break; }
    }
    if (!test || test.status !== "active") return false;
    var hypothesis = pickHypothesis(test, side);
    if (!hypothesis || hypothesis.type !== "price") return false;
    var variants = hypothesis.priceData && hypothesis.priceData.variants;
    if (!Array.isArray(variants)) return false;
    var rowFound = false;
    for (var j = 0; j < variants.length; j++) {
      if (markerRow(variants[j])) { rowFound = true; break; }
    }
    return rowFound;
  }

  function selectorTargetsProduct(variant) {
    var selectors = variant && variant.domSelectors;
    if (!Array.isArray(selectors)) return false;
    var pattern = new RegExp('data-sl-attribute-(?:p|cap)="' + TARGET_PRODUCT_ID + '"');
    for (var i = 0; i < selectors.length; i++) {
      var cssSelector = selectors[i] && selectors[i].cssSelector;
      if (typeof cssSelector === "string" && pattern.test(cssSelector)) return true;
    }
    return false;
  }

  function scopeIsPreview(inst, testId, side) {
    var state = inst.state;
    if (!state || !state.temporary || state.temporary.isMerchant !== true) return false;
    var preview = state.temporary.previewConfig;
    if (!preview || preview.testTypeCategory !== 5 || preview.testId !== testId) return false;
    if (!Array.isArray(preview.variants)) return false;
    var variant = null;
    for (var i = 0; i < preview.variants.length; i++) {
      if (preview.variants[i] && preview.variants[i].id === preview.currentVariant) { variant = preview.variants[i]; break; }
    }
    if (!variant || variant.isControl !== (side === "control")) return false;
    return selectorTargetsProduct(variant);
  }

  function readValidatedMarker() {
    var raw = window.__shopliftPriceTestValue;
    if (typeof raw !== "string") return null;
    var match = raw.match(MARKER_RE);
    if (!match) return null;
    var inst = window.shopliftInstance;
    if (!inst || !inst.state) return null;
    var testId = match[1];
    var side = match[2].toLowerCase();
    var kind = match[3].toLowerCase();
    var ok = kind === "t" ? scopeIsPreview(inst, testId, side) : scopeIsLive(inst, testId, side);
    return ok ? raw : null;
  }

  function matchingOfferWidget(widgetId) {
    var targetId = widgetId || WIDGET_ID;
    var zones = window.dynamaticZones;
    if (!zones || typeof zones !== "object") return null;
    var keys = Object.keys(zones);
    var found = null;
    var count = 0;
    for (var i = 0; i < keys.length; i++) {
      var zone = zones[keys[i]];
      var audiences = zone && zone.audiences;
      if (!Array.isArray(audiences)) continue;
      for (var a = 0; a < audiences.length; a++) {
        var experiences = audiences[a] && audiences[a].experiences;
        if (!Array.isArray(experiences)) continue;
        for (var e = 0; e < experiences.length; e++) {
          var variations = experiences[e] && experiences[e].variations;
          if (!Array.isArray(variations)) continue;
          for (var v = 0; v < variations.length; v++) {
            var widgets = variations[v] && variations[v].widgets;
            if (!Array.isArray(widgets)) continue;
            for (var w = 0; w < widgets.length; w++) {
              var widget = widgets[w];
              if (!widget || String(widget.id) !== targetId) continue;
              count += 1;
              if (count > 1) return null;
              found = widget;
            }
          }
        }
      }
    }
    return count === 1 ? found : null;
  }

  function validOfferType(widget) {
    var property = widget && widget.property;
    var cart = property && property.cart;
    var content = cart && cart.content;
    var general = content && content.general;
    var offerType = general && general.offerType;
    if (!offerType || typeof offerType !== "object") return false;
    return offerType.type === "discounted-item" &&
      offerType.action === "customer-choice" &&
      offerType.numOfAllowedItems === 1 &&
      offerType.discountMethod === "shopify-function" &&
      offerType.discountType === "percentage" &&
      offerType.discountAmount === 20 &&
      offerType.calculateDiscount === "per-item" &&
      offerType.applyDiscountWhenItemInCart === false;
  }

  function readOfferBaseCents(testId, side) {
    var inst = window.shopliftInstance;
    var configs = inst && inst.testConfigs;
    if (!Array.isArray(configs)) return null;
    var test = null;
    var configCount = 0;
    for (var i = 0; i < configs.length; i++) {
      if (configs[i] && configs[i].id === testId) {
        configCount += 1;
        test = configs[i];
      }
    }
    if (configCount !== 1) return null;

    var hypotheses = test && test.hypotheses;
    if (!Array.isArray(hypotheses)) return null;
    var wantControl = side === "control";
    var hypothesis = null;
    var hypothesisCount = 0;
    for (var j = 0; j < hypotheses.length; j++) {
      if (hypotheses[j] && hypotheses[j].isControl === wantControl) {
        hypothesisCount += 1;
        hypothesis = hypotheses[j];
      }
    }
    if (hypothesisCount !== 1) return null;
    if (!hypothesis || hypothesis.type !== "price") return null;

    var priceData = hypothesis.priceData;
    if (!priceData || priceData.currency !== "USD") return null;
    var variants = priceData.variants;
    if (!Array.isArray(variants)) return null;
    var baseCents = null;
    var rowCount = 0;
    for (var k = 0; k < variants.length; k++) {
      var row = variants[k];
      if (!Array.isArray(row)) continue;
      if (String(row[0]) !== TARGET_VARIANT_ID || String(row[3]) !== TARGET_PRODUCT_ID) continue;
      rowCount += 1;
      baseCents = Number(row[1]);
    }
    if (rowCount !== 1) return null;
    if (typeof baseCents !== "number" || !Number.isSafeInteger(baseCents) || baseCents <= 0) return null;
    return baseCents;
  }

  // Read-only: returns the assigned second-Capo prices derived from the
  // already-validated marker, the matching test/hypothesis price row and the
  // matching runtime widget offer config. Returns null on any mismatch and
  // never mutates state, assignments, price config or runtime zones.
  function getOfferPrices() {
    try {
      var marker = readValidatedMarker();
      if (marker === null) return null;
      var match = marker.match(MARKER_RE);
      if (!match) return null;
      var baseCents = readOfferBaseCents(match[1], match[2].toLowerCase());
      if (baseCents === null) return null;

      var widget = matchingOfferWidget();
      if (!widget) return null;
      if (!(widget.active === 1 || widget.active === true)) return null;
      if (widget.currency_code !== "USD") return null;
      if (!validOfferType(widget)) return null;

      return {
        baseCents: baseCents,
        discountedCents: baseCents - Math.floor(baseCents * 20 / 100),
        currency: "USD",
      };
    } catch (error) {
      return null;
    }
  }

  function listHasNoDiscount(widget) {
    var content = widget && widget.property && widget.property.cart && widget.property.cart.content;
    if (!content || typeof content !== "object") return false;
    var general = content.general || {};
    var section = content.discountSection || {};
    return general.haveDiscount !== true && section.haveDiscount !== true;
  }

  // Read-only: the shopper's full Capo price for the Best Sellers List card,
  // from the same validated marker and price row as getOfferPrices. Null on
  // any mismatch, including any discount configured on widget 2418.
  function getListPrices() {
    try {
      var marker = readValidatedMarker();
      if (marker === null) return null;
      var match = marker.match(MARKER_RE);
      if (!match) return null;
      var baseCents = readOfferBaseCents(match[1], match[2].toLowerCase());
      if (baseCents === null) return null;

      var widget = matchingOfferWidget(LIST_WIDGET_ID);
      if (!widget) return null;
      if (!(widget.active === 1 || widget.active === true)) return null;
      if (widget.currency_code !== "USD") return null;
      if (String(widget.template) !== LIST_TEMPLATE_ID) return null;
      if (!listHasNoDiscount(widget)) return null;

      return { baseCents: baseCents, currency: "USD" };
    } catch (error) {
      return null;
    }
  }

  function isEligibleListItem(item, properties) {
    if (String(properties._dyn_cart_widget_id) !== LIST_WIDGET_ID) return false;
    if (String(properties._dyn_cart_widget_template) !== LIST_TEMPLATE_ID) return false;
    for (var i = 0; i < DISCOUNT_KEYS.length; i++) {
      if (Object.prototype.hasOwnProperty.call(properties, DISCOUNT_KEYS[i])) return false;
    }
    return true;
  }

  function isEligibleItem(item) {
    if (!item || typeof item !== "object" || Array.isArray(item)) return false;
    if (String(item.id) !== TARGET_VARIANT_ID) return false;
    var properties = item.properties;
    if (!properties || typeof properties !== "object" || Array.isArray(properties)) return false;
    if (isEligibleListItem(item, properties)) return true;
    if (String(properties._dyn_cart_widget_id) !== WIDGET_ID) return false;
    if (typeof properties._dyn_custom_property !== "string" || properties._dyn_custom_property.indexOf("afg-") !== 0) return false;
    if (typeof properties.__dyn_discount_custom !== "string") return false;
    return true;
  }

  function markerMissing(properties) {
    if (!Object.prototype.hasOwnProperty.call(properties, "_slpt")) return true;
    var value = properties._slpt;
    if (value === null || value === undefined) return true;
    return typeof value === "string" && value.trim() === "";
  }

  // Shared by fetch and XHR: validate the request target/scope and return the
  // replacement JSON string, or null to forward the original body unchanged.
  function replacementBody(rawUrl, method, bodyString) {
    if (typeof rawUrl !== "string") return null;
    if (typeof method !== "string" || method.toUpperCase() !== "POST") return null;
    if (typeof bodyString !== "string") return null;

    var parsed;
    try { parsed = new URL(rawUrl, location.href); } catch (error) { return null; }
    if (parsed.origin !== location.origin || !CART_ADD_RE.test(parsed.pathname)) return null;

    var body;
    try { body = JSON.parse(bodyString); } catch (error) { return null; }
    if (!body || typeof body !== "object" || !Array.isArray(body.items)) return null;

    var marker = readValidatedMarker();
    if (marker === null) return null;

    var clonedItems = body.items.slice();
    var changed = false;
    for (var i = 0; i < clonedItems.length; i++) {
      var item = clonedItems[i];
      if (!isEligibleItem(item) || !markerMissing(item.properties)) continue;
      var clonedItem = shallowClone(item);
      var clonedProperties = shallowClone(item.properties);
      clonedProperties._slpt = marker;
      clonedItem.properties = clonedProperties;
      clonedItems[i] = clonedItem;
      changed = true;
    }
    if (!changed) return null;

    var clonedBody = shallowClone(body);
    clonedBody.items = clonedItems;
    return JSON.stringify(clonedBody);
  }

  function replacementArgs(input, init, args) {
    var requestLike = isRequestLike(input);
    var hasInit = !!init && typeof init === "object";
    if (requestLike && !(hasInit && typeof init.body === "string")) return null;
    if (!hasInit || typeof init.body !== "string") return null;

    var method = typeof init.method === "string" ? init.method : (requestLike ? input.method : "GET");
    if (String(method).toUpperCase() !== "POST") return null;

    var signal = init.signal || (requestLike ? input.signal : null);
    if (signal && signal.aborted) return null;

    var rawUrl = typeof input === "string" ? input : (input instanceof URL ? input.href : (requestLike ? input.url : null));
    var replacement = replacementBody(rawUrl, method, init.body);
    if (replacement === null) return null;

    var clonedInit = shallowClone(init);
    clonedInit.body = replacement;
    var out = args.length > 2 ? Array.prototype.slice.call(args) : [input, clonedInit];
    if (out.length > 2) out[1] = clonedInit;
    return out;
  }

  function wrappedFetch(input, init) {
    var args = arguments;
    var replacement = null;
    try {
      replacement = replacementArgs(input, init, args);
    } catch (error) {
      replacement = null;
    }
    return originalFetch.apply(this, replacement || args);
  }

  var installedFetch = false;
  if (originalFetch) {
    wrappedFetch.__bmDynamaticShopliftBridge = true;
    window.fetch = wrappedFetch;
    installedFetch = true;
  }

  var xhrMetadata = null;
  var originalXhrOpen = null;
  var originalXhrSend = null;
  var wrappedXhrOpen = null;
  var wrappedXhrSend = null;
  var installedXhr = false;

  if (canWrapXhr) {
    xhrMetadata = new WeakMap();
    originalXhrOpen = xhrPrototype.open;
    originalXhrSend = xhrPrototype.send;

    wrappedXhrOpen = function (method, url) {
      var result;
      try {
        result = originalXhrOpen.apply(this, arguments);
      } catch (error) {
        // A failed open must not leave metadata from an earlier successful open.
        xhrMetadata.delete(this);
        throw error;
      }
      xhrMetadata.set(this, { method: method, url: url });
      return result;
    };

    wrappedXhrSend = function (body) {
      var metadata = xhrMetadata.get(this);
      var replacement = null;
      // readyState 1 means opened and not yet sent/aborted; an abort resets it
      // to 0 so the original body is forwarded untouched.
      if (metadata && this.readyState === 1 && typeof body === "string") {
        try {
          replacement = replacementBody(metadata.url, metadata.method, body);
        } catch (error) {
          replacement = null;
        }
      }
      if (replacement === null) {
        return originalXhrSend.apply(this, arguments);
      }
      var args = Array.prototype.slice.call(arguments);
      args[0] = replacement;
      return originalXhrSend.apply(this, args);
    };

    xhrPrototype.open = wrappedXhrOpen;
    xhrPrototype.send = wrappedXhrSend;
    installedXhr = true;
  }

  window.__bmDynamaticShopliftBridge = {
    installed: true,
    getOfferPrices: getOfferPrices,
    getListPrices: getListPrices,
    restore: function () {
      var fetchRestored = !installedFetch;
      if (installedFetch) {
        if (window.fetch === wrappedFetch) {
          window.fetch = originalFetch;
          fetchRestored = true;
        } else {
          fetchRestored = false;
        }
      }

      var xhrRestored = !installedXhr;
      if (installedXhr) {
        // Restore open/send only together, and only when both are still ours,
        // so a later wrapper is never clobbered.
        if (xhrPrototype.open === wrappedXhrOpen && xhrPrototype.send === wrappedXhrSend) {
          xhrPrototype.open = originalXhrOpen;
          xhrPrototype.send = originalXhrSend;
          xhrRestored = true;
        } else {
          xhrRestored = false;
        }
      }

      if (fetchRestored && xhrRestored) {
        delete window.__bmDynamaticShopliftBridge;
        return true;
      }
      return false;
    }
  };
})();
